import repository from 'client/repository';
import asyncBuilder from 'utilities/actions';

const refresh = asyncBuilder(
    'REFRESH',
    (qrCode, refreshToken) => repository.auth.refresh(qrCode, refreshToken),
    (qrCode, refreshToken) => ({ qrCode, refreshToken })
);

export default refresh;